<section
  class="user-profile-classes-subpage profile-section"
  [class.mobile]="deviceService.isMobile()"
  [class.tablet]="deviceService.isTablet()"
  *ngIf="services.items.length || isMe || !view">
  <section class="section section-individual-sessions" rel="services">
    <div class="individual-header" [class.individual-header_no-free-hours]="!isMe && !hasFreeHours()">
      <app-title [title]="'user-profile.tab-classes'"></app-title>
    </div>

    <ng-container *ngIf="services.loaded && services.items.length; else noClasses">
      <app-filter-content
        *ngIf="userServiceCategoryTabs.length > 2"
        [tabs]="userServiceCategoryTabs"
        [activeTab]="selectUserServicesFilter"
        (onSelect)="onSelectOtherUserServicesFilter($event)">
      </app-filter-content>

      <div class="user-service-cards-wrap">
        <ng-container *ngIf="services?.items?.length > 0">
          <ng-container *ngFor="let userService of services?.items; trackBy: trackUserServiceByFn; let idx = index">
            <div class="user-service-card-wrap">
              <app-user-service-card-2
                [displayMode]="view || 'narrow2'"
                [service]="userService"
                [authorDisplay]="false"
                (selected)="editService = userService"
                (openCheckout)="openCheckoutModal($event)"
                (openUserServiceInModal)="onToggleUserServiceInModal($event)">
              </app-user-service-card-2>
            </div>
          </ng-container>

          <loading-line *ngIf="services.loading" height="40px" width="100%"></loading-line>
          <span *ngIf="!view" inViewport (inViewportAction)="onInViewportBottomChange($event)"></span>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #noClasses>
      <div class="empty-content">
        <app-empty *ngIf="isMe && services.loaded" [empty]="emptyClassesObj"></app-empty>
      </div>
    </ng-template>
  </section>
</section>

<ng-container *ngIf="userServiceCardFullInModal">
  <app-modal *ngIf="deviceService.isDesktop()" [canClose]="false" (closed)="onToggleUserServiceInModal()">
    <app-modal-body>
      <app-user-service-card-full
        [userService]="openedUserService"
        [modal]="true"
        (inViewportChange)="onIinViewportChange($event)"
        (isCloseAllModals)="onToggleUserServiceInModal()">
      </app-user-service-card-full>
    </app-modal-body>
    <app-modal-ad>
      <ng-container *ngIf="!surfaceBlockDisplay">
        <app-user-service-surface-block [userService]="openedUserService"></app-user-service-surface-block>
      </ng-container>
    </app-modal-ad>
  </app-modal>

  <app-mobile-modal *ngIf="!deviceService.isDesktop()" [titleVisible]="true" (closed)="onToggleUserServiceInModal()">
    <app-mobile-modal-body>
      <app-user-service-card-full [userService]="openedUserService" [modal]="true"></app-user-service-card-full>
    </app-mobile-modal-body>
  </app-mobile-modal>
</ng-container>

<ng-container *ngIf="editService">
  <app-modal *ngIf="!deviceService.isMobile()" (closed)="onCancel()">
    <app-modal-body>
      <app-user-service-form-3
        [teachingSubjects]="_profile.teachingSubjects"
        [sourceMode]="'bff'"
        [userService]="editService"
        (changed)="onChange()">
      </app-user-service-form-3>
    </app-modal-body>
  </app-modal>

  <app-mobile-modal
    *ngIf="deviceService.isMobile()"
    [titleVisible]="false"
    [withCloseButton]="true"
    [customTitle]="'teacher-profile.edit-service' | translate"
    (closed)="onCancel()">
    <app-mobile-modal-body>
      <app-user-service-form-3
        [teachingSubjects]="_profile.teachingSubjects"
        [sourceMode]="'bff'"
        [userService]="editService"
        (changed)="onChange()">
      </app-user-service-form-3>
    </app-mobile-modal-body>
  </app-mobile-modal>
</ng-container>
